<div *ngIf="paycheckErrorList && paycheckErrorList.length==1 && paycheckErrorList[0].code=='143' &&  paycheckErrorList[0].description=='Vendor does not have access to the resource.'">
 <h2 mat-dialog-title style="color: #007aff !important">
    Info:  Record Synced – Now Managed by PointClickCare
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  This record has been synced and can only be updated in PointClickCare. <br>
  Please log in there to make any changes.
</div>

<div *ngIf="paycheckErrorList && paycheckErrorList[0].code!='143'">

  <h2 mat-dialog-title>
    {{title}}
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <table class="table table-responsive">
      <thead>
          <th>Name</th>
          <!-- <th>Code</th> -->
          <th>Description</th>         
      </thead>
      <tbody>
          <tr *ngFor='let item of paycheckErrorList'>
              <td>{{item.name}}</td>
              <!-- <td>{{item.code}}</td> -->
              <td>{{item.description}}</td>               
          </tr>
      </tbody>
  </table>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Cancel</button>    
    <button mat-button (click)="executeReset()" color="primary" *ngIf="reCreateState" >Reset </button>    
  </mat-dialog-actions>


</div>